import { 
    Box, 
    MenuItem,
    Select,
} from '@mui/material';
import { redirectsViewModes } from '..';

const RedirectsViewModeSelect = props => {
    
    const {
        redirectsNumOfResults,
        redirectsViewMode,
        setRedirectsViewMode,
        matchesRedirectsHistoryOnly,
    } = props;

    return (
        <Box>
            {
                matchesRedirectsHistoryOnly ?
                <Box sx={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                }}>
                    Redirect History ({ redirectsNumOfResults })
                </Box> :
                <Select
                    variant='standard'
                    id="select-redirects-view-mode"
                    value={redirectsViewMode}
                    onChange={setRedirectsViewMode}
                    disableUnderline
                    renderValue={
                        () => redirectsViewMode === redirectsViewModes.history ? 
                        `Redirect History (${redirectsNumOfResults})` :
                        `Redirect Chart (${redirectsNumOfResults})`
                    }
                    sx={{
                        minWidth: '200px',
                        fontSize: '24px',
                        fontWeight: 'bold',
                    }}
                >
                    <MenuItem value='history'>
                        Redirect History
                    </MenuItem>
                    <MenuItem value='chart'>
                        Redirect Chart
                    </MenuItem>
                </Select>
            }
        </Box>
    );
}

export default RedirectsViewModeSelect;